module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.wrapClasses
  }, [(_vm.type !== 'textarea') ? [(_vm.prepend) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slotReady),
      expression: "slotReady"
    }],
    class: [_vm.prefixCls + '-group-prepend']
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('i', {
    staticClass: "ivu-icon",
    class: ['ivu-icon-' + _vm.icon, _vm.prefixCls + '-icon', _vm.prefixCls + '-icon-normal'],
    on: {
      "click": _vm.handleIconClick
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.icon) ? _c('i', {
    staticClass: "ivu-icon ivu-icon-load-c ivu-load-loop",
    class: [_vm.prefixCls + '-icon', _vm.prefixCls + '-icon-validate']
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.inputClasses,
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "number": _vm.number,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleEnter($event)
      },
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": _vm.handleInput,
      "change": _vm.handleChange
    }
  }), _vm._v(" "), (_vm.append) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slotReady),
      expression: "slotReady"
    }],
    class: [_vm.prefixCls + '-group-append']
  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', {
    ref: "textarea",
    class: _vm.textareaClasses,
    style: (_vm.textareaStyles),
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "rows": _vm.rows,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleEnter($event)
      },
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": _vm.handleInput
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56fb177e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/input/input.vue
// module id = 633
// module chunks = 1